export default {
  namespaced: true,
  tenants: {
    title: "tenant | tenants",
    title_plural: "Tenants",
    number_of_routers: "Número de Routers",
    _name: "Nombre",
    main_image: "Imagen principal",
    logo_image: "imagen Logo",
    image_mobile_app: "Imagen App Movil",
    all: "todos los tenants",
    shared: "tenants compartidos",
    file_storage: "Almacenamiento de archivos",
    store:{
      tenant_storage: "Tenant almacenamiento",
      storage: "Almacenamiento",
      storage_service: "Servicio de almacenamiento",
      assigned_space: "Espacio asignado",
      assigned_space_gb: "Espacio asignado gb",
      assigned_space_mb: "Espacio asignado mb",
      used_space: "Espacio usado",
      used_space_gb: "Espacio usado gb",
      used_space_mb: "Espacio usado mb",
      type: "Tipo",
      files: "Archivos",
      assigned_space_min: "Espacio mínimo asignado",
      assigned_space_max: "Espacio máximo asignado",
      used_space_min: "Espacio mínimo usado",
      used_space_max: "Espacio máximo usado",
    },
    file:{
      image: "Imagen",
      id: "Id",
      name: "Nombre",
      extension: "Extensión",
      size: "Tamaño",
      storage_type: "Tipo almacenamiento",
      directory: "Directorio",
      last_access: "Ultimo acceso",
      size_min: "Tamaño mínimo",
      size_max: "Tamaño maximo",
      created_from: "Creado desde",
      created_to: "Creado hasta",
      file_explorer: "Explorador de Archivos",
      subdirectories_and_direct_files: "Subdirectorios y archivos directos",
      direct_files: "Archivos directos",
      files_in_subdirectory: "Archivos en subdirectorios"
    },
    message:{
      add: "Tenant Agregado Correctamente",
      edit: "Tenant Editado Correctamente",
      delete: "Tenant Eliminado Correctante",
      error: "Ocurrio un error",
    }
  },
};
